import { render, staticRenderFns } from "./AddChartButton.vue?vue&type=template&id=5e8d5c1f&scoped=true"
var script = {}
import style0 from "./AddChartButton.scss?vue&type=style&index=0&id=5e8d5c1f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8d5c1f",
  null
  
)

export default component.exports